import Axios from "axios";
import {
    SET_APPROVAL_NAME_LIST,
    UNSET_APPROVAL_NAME_LIST
  } from "@/store/mutation-types";
import { saveUpdateApprovalName, getApprovalNameList  } from "@/store/api";
// initial state
const state = {
  getApprovalNameList: [],
};

const getters = {
  getApprovalNameList(state) {
    return state.getApprovalNameList;
  },
};
const mutations = {
  [SET_APPROVAL_NAME_LIST](state, data) {
    state.getApprovalNameList = data;
  },
  [UNSET_APPROVAL_NAME_LIST](state) {
    state.getApprovalNameList = [];
  },

};

const actions = {

  saveUpdateApprovalName({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateApprovalName, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getApprovalNameList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getApprovalNameList)
        .then(function (response) {
          commit('SET_APPROVAL_NAME_LIST',response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_APPROVAL_NAME_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },


};

export default {
  state,
  getters,
  actions,
  mutations,
};
